import React from "react";
import {PartyDisplayApiJson} from "./IssueApiJson";

export function formatPartyDisplay(party: PartyDisplayApiJson | null | undefined): string {
    if (!party) {
        return "—";
    }
    if (party.unresolved) {
        return "(nieznany)";
    }
    return party.email ? `${party.name} (${party.email})` : party.name;
}

export function PartyDisplay(props: {
    party: PartyDisplayApiJson | null | undefined,
}) {
    const party = props.party;
    if (!party) {
        return <span>—</span>;
    }
    if (party.unresolved) {
        return <span className={"text-gray-500 fst-italic"}>(nieznany)</span>;
    }
    const text = party.email ? `${party.name} (${party.email})` : party.name;
    return <span>{text}</span>;
}

export function IssuePartyLines(props: {
    reporter: PartyDisplayApiJson | null | undefined,
    assignee: PartyDisplayApiJson | null | undefined,
}) {
    return <div className={"d-flex flex-column gap-1 mt-1"}>
        <div className={"text-gray-700 fs-7"}>
            <span className={"text-gray-500"}>Rep:</span> <PartyDisplay party={props.reporter}/>
        </div>
        <div className={"text-gray-700 fs-7"}>
            <span className={"text-gray-500"}>Op:</span> <PartyDisplay party={props.assignee}/>
        </div>
    </div>;
}
